import Button from "./Button";
import HighlightContainer from "./HighlightContainer";
import Input from "./Input";
import ViewportSection from "./ViewportSection";
import SimpleSpinner from "./SimpleSpinner";
import { colors } from "src/common/constants";

const globalLinearBackground = `linear-gradient(to right, ${colors.blue1}, ${colors.blue2})`;

export {
  Button,
  HighlightContainer,
  Input,
  ViewportSection,
  SimpleSpinner,
  globalLinearBackground,
};
